import React from 'react';

import type { IdCompanyDto } from '@/services/ws-permissions/src/main/resources/rest-api';
import { getAllManagingCompaniesNames } from '@/services/ws-permissions/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import type { IdentityRole } from '@/js/libs/use-auth';
import { useIdentityUser } from '@/js/libs/use-auth';
import { NotActive, useRequest } from '@/js/libs/use-request';

import type { Option } from 'src/types';

type UseCompaniesOptionsReturn = {
  options: Option<IdCompanyDto>[];
  pending: boolean;
};

type UseCompaniesOptions = (permissions: IdentityRole[]) => UseCompaniesOptionsReturn;

export const useCompaniesOptions: UseCompaniesOptions = (permissions) => {
  const user = useIdentityUser();

  const getAllManagingCompaniesNamesRequest = useRequest({
    apiMethod: getAllManagingCompaniesNames,
    params: user?.company.id ? { id: user.company.id, permissions } : NotActive,
  });

  const options = useSubscribe(
    getAllManagingCompaniesNamesRequest.data$,
    (response) => response?.data.map((company) => ({ label: company.name, value: company.id })) ?? [],
  );
  const pending = useSubscribe(getAllManagingCompaniesNamesRequest.pending$);

  return React.useMemo<UseCompaniesOptionsReturn>(() => ({ options, pending }), [options, pending]);
};
